export default __webpack_public_path__ + "static/media/02-VEH-(2-2).6cc1e2a4.jpg";